import { UserRankingCategoryBase } from './base/user-ranking-category-base';

export class UserRankingCategory extends UserRankingCategoryBase { }